import React from "react";

import * as S from "./Button.Style";

const Button = ({ children, variant = "link", ...props }) => {
  return (
    <S.ButtonContainer as={props?.as} $variant={variant} {...props}>
      {children}
    </S.ButtonContainer>
  );
};

export default Button;
